var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPloygon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ploygon",
    transform: "translate(-1056 -2909)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1137",
    "data-name": "Rectangle 1137",
    width: 20,
    height: 20,
    transform: "translate(1056 2909)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M29.994,20.723a1.2,1.2,0,0,0-1.2,0l-2.749,1.638-1.868,1.068-2.749,1.638a1.2,1.2,0,0,1-1.2,0l-2.185-1.282a1.23,1.23,0,0,1-.6-1.032V20.224a1.156,1.156,0,0,1,.6-1.032l2.15-1.246a1.2,1.2,0,0,1,1.2,0l2.15,1.246a1.23,1.23,0,0,1,.6,1.032v1.638l1.868-1.1V19.121a1.156,1.156,0,0,0-.6-1.032l-3.983-2.35a1.2,1.2,0,0,0-1.2,0l-4.053,2.35a1.156,1.156,0,0,0-.6,1.032v4.735a1.156,1.156,0,0,0,.6,1.032l4.053,2.35a1.2,1.2,0,0,0,1.2,0l2.749-1.6,1.868-1.1,2.749-1.6a1.2,1.2,0,0,1,1.2,0l2.15,1.246a1.23,1.23,0,0,1,.6,1.032v2.528a1.156,1.156,0,0,1-.6,1.032l-2.15,1.282a1.2,1.2,0,0,1-1.2,0L26.645,28.8a1.23,1.23,0,0,1-.6-1.032V26.134l-1.868,1.1v1.638a1.156,1.156,0,0,0,.6,1.032l4.053,2.35a1.2,1.2,0,0,0,1.2,0l4.053-2.35a1.23,1.23,0,0,0,.6-1.032V24.141a1.156,1.156,0,0,0-.6-1.032Z",
    transform: "translate(1040.422 2895.422)",
    fill: "#7b3fe4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPloygon);
export default __webpack_public_path__ + "static/media/ploygon.5e57fa7f246076cc4fe2a66d627c4a63.svg";
export { ForwardRef as ReactComponent };